import Api from '@/shared/services/Api'


export default 
{

	get() {
		return Api().get('accounts-api-get')
	},

	updateStatus(data) {
		return Api().post('accounts-api-update-status', data)
	},

	getPercUtility() {
		return Api().get('accounts-api-get-perc-utility')
	},

	updatePercUtility(percUtility) {
		return Api().get('accounts-api-update-perc-utility?percUtility='+percUtility)
	},

	getOne(id) {
		return Api().get('accounts-api-get-one?id='+id)
	},

	update(data) {
		return Api().post('accounts-api-update', data)
	},

}